import * as yup from 'yup';
import { emailRegExp } from '../helpers/emailRegExp';

export const UserEmailSchema = yup.object({
  email: yup
    .string()
    .matches(emailRegExp, 'Invalid Email Address')
    .required('Email is required'),
});
